"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _LogService = require("../../../../KESI2/Services/LogService");

var _ResumeSuspendListeners = require("../../../../helpers/ResumeSuspendListeners");

var WatchedSequences = /*#__PURE__*/function () {
  /**
   *
   * @param videoNugget {VideoNugget}
   * @param videoElement {HtmlElement}
   */
  function WatchedSequences(videoNugget, videoElement) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, WatchedSequences);
    (0, _defineProperty2["default"])(this, "postLogMessage", function () {
      _this._addCurrentSequence();

      if (_this.watchedSequences.sequences.length > 0) {
        (0, _LogService.pushVideoUsageLogMessage)(_this.videoNugget.id, null, _this.watchedSequences.sequences, _this.watchedSequences.chapters);
      }

      return _this._reset();
    });
    (0, _defineProperty2["default"])(this, "onPlay", function () {
      if (_this.player.currentTime) {
        _this.latestStart = _this.player.currentTime;
      }
    });
    (0, _defineProperty2["default"])(this, "onPause", function () {
      _this._addCurrentSequence();
    });
    (0, _defineProperty2["default"])(this, "onSeeked", function () {
      _this._addCurrentSequence();

      _this.latestStart = _this.player.currentTime;
    });
    (0, _defineProperty2["default"])(this, "onSeeking", function () {
      _this._addCurrentSequence();

      _this.latestStart = _this.player.currentTime;
    });
    (0, _defineProperty2["default"])(this, "onTimeupdate", function () {
      /*
       * Some devices send neither seeking nor seeked events (e.g. iPad iOS 7).
       * They also don't set the seeking property.
       * So we calculate if the timing suggests that the user seeked.
       * This method fails if the users drags at roughly the same speed as the
       * video would play but it's the best we can do without the necessary events.
       */
      var actualTimeDelta;
      var playerDelta;
      playerDelta = _this.player.currentTime - _this.latestPosition;
      actualTimeDelta = (0, _now["default"])() - _this.lastTimeupdateEvent;
      actualTimeDelta /= 1000;
      _this.lastTimeupdateEvent = (0, _now["default"])();

      if (Math.abs(playerDelta - actualTimeDelta) > 1) {
        _this._addCurrentSequence();

        _this.latestStart = _this.player.currentTime;
      }

      _this.latestPosition = _this.player.currentTime;
    });
    this.videoNugget = videoNugget;
    this.player = videoElement;
    this.lastTimeupdateEvent = null;
    this.watchedSequences = {
      sequences: [],
      chapters: []
    };
    this.latestStart = 0;
    this.latestPosition = 0;
    this.lastTimeupdateEvent = (0, _now["default"])();
    this.initForPlayer();
  }

  (0, _createClass2["default"])(WatchedSequences, [{
    key: "postAndUnload",
    value: function postAndUnload() {
      this.postLogMessage();
      (0, _ResumeSuspendListeners.removeOnSuspendListener)(this.postLogMessage);
      this.player.removeEventListener('timeupdate', this.onTimeupdate);
      this.player.removeEventListener('seeking', this.onSeeking);
      this.player.removeEventListener('seeked', this.onSeeked);
      this.player.addEventListener('pause', this.onPause);
      this.player.addEventListener('play', this.onPlay);
    }
  }, {
    key: "_addCurrentSequence",
    value: function _addCurrentSequence() {
      if (this.latestPosition > this.latestStart + 1) {
        this.watchedSequences.sequences.push({
          start: this.latestStart,
          end: this.latestPosition
        });
      }

      this.latestStart = 0;
      this.latestPosition = 0;
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this.watchedSequences = {
        sequences: [],
        chapters: []
      };
      this.latestStart = 0;
      this.latestPosition = 0;
    }
  }, {
    key: "addChapter",
    value: function addChapter(chapterName) {
      console.log("adding ".concat(chapterName, " to watched chapters"));
      return this.watchedSequences.chapters.push(chapterName);
    }
  }, {
    key: "initForPlayer",
    value: function initForPlayer() {
      (0, _ResumeSuspendListeners.addOnSuspendListener)(this.postLogMessage);
      this.player.addEventListener('timeupdate', this.onTimeupdate);
      this.player.addEventListener('seeking', this.onSeeking);
      this.player.addEventListener('seeked', this.onSeeked);
      this.player.addEventListener('pause', this.onPause);
      this.player.addEventListener('play', this.onPlay);
    }
  }]);
  return WatchedSequences;
}();

var _default = WatchedSequences;
exports["default"] = _default;